import { post,get } from "@/axios/index"
export const setMysubscription = (p) => post("/mini/setMySubscription", p)
export const setMysubscriptionManage = (p) => post("/mini/setMySubscription/"+p.clientId, p.post)
export const getMySubscription  = (p) => get("/mini/getMySubscription", p)
export const getAllSubscription= (p) => get("/mini/getAllSubscription", p)